import { FC } from "react";

import { MenuIcon } from "@repo/edtech-assets";
import { useIsMobile } from "@repo/edtech-shared";
import { Sidebar } from "@repo/edtech-ui-kit";
import clsx from "clsx";

import {
  Course,
  CourseStatuses,
  MOBILE_WIDTH,
  useMainContextValues,
} from "../../../../model";
import { getConfig, t } from "../../../../origins";
import { StatusTag } from "../../status-tag";
import { ListLesson } from "./components";

import st from "./CourseContent.module.scss";

type Props = {
  courseData: Course,
  isAside?: boolean,
};

export const CourseContent: FC<Props> = ({
  courseData,
  isAside,
}) => {
  const { rootNodeIds } = useMainContextValues();
  const isMobile = useIsMobile(MOBILE_WIDTH);
  const {
    isBasicCourseContentButton,
  } = getConfig();

  return (
    <Sidebar
      actions={
        (onClose) => (
          <button
            aria-label={t("courseContent.closeAriaLabel")}
            className={clsx("edtech-course-completion", st.close_btn)}
            onClick={onClose}
          >
            {t("courseContent.closeButton")}
          </button>
        )
      }
      closeOnBackDropClick={!isMobile}
      title={
        (<>
          <div className={st.tags}>
            <StatusTag status={courseData?.status as CourseStatuses} />
          </div>
          <div className={st.header}>
            <h2 className={st.title}>{courseData?.mainChapterTitle}</h2>
          </div>
        </>)
      }
      Trigger={
        (<button
          aria-label={t("courseContent.openAriaLabel")}
          className={
            clsx(
              st.content_button,
              isAside && st.content_button_aside,
              isBasicCourseContentButton && st.basic_button_color,
            )
          }
        >
          <MenuIcon className={clsx(st.content_button_icon)} />
          <span className={st.content_button_text}>
            {t("courseContent.triggerPrefix")}
            {" "}
            {t("courseContent.suffix")}
          </span>
        </button>)
      }
      width={isMobile ?
        undefined :
        "600px"}
    >
      {
        (onClose) => (
          <div className={clsx("edtech-course-completion", st.list)}>
            <ListLesson
              closeCourseContentAction={onClose}
              currentList={rootNodeIds!}
            />
          </div>
        )
      }
    </Sidebar>
  );
};
